import openapiSchema from '@openapi';

const { paths } = openapiSchema as { paths: Record<string, unknown> };

// The schema spells most paths with a trailing slash, the app builds its URLs without one
// (and appends `/${id}` to them), so both sides are compared stripped.
const stripTrailingSlash = (path: string) => path.replace(/\/$/, '');

const maasPaths = new Set(
  Object.keys(paths)
    .filter((p: string) => p.startsWith('/api/v2/compute/maas'))
    .map(stripTrailingSlash)
);

const requirePath = (path: string) => {
  if (!maasPaths.has(path)) {
    throw new Error(`MAAS path missing in backend schema: ${path}`);
  }
  return path;
};

const pathMigrations = requirePath('/api/v2/compute/maas/migrations');
const pathMigrationsDeployments = requirePath('/api/v2/compute/maas/migrations/{migration_id}/deployments');
const pathMigrationsReplications = requirePath('/api/v2/compute/maas/migrations/{migration_id}/replications');
const pathClouds = requirePath('/api/v2/compute/maas/clouds');
const pathCloudInstances = requirePath('/api/v2/compute/maas/clouds/{cloud_id}/instances/{instance_id}');
const pathCloudInstanceFetch = requirePath('/api/v2/compute/maas/clouds/{cloud_id}/instances/{instance_id}/fetch');

export const getMigrationsUrl = () => pathMigrations;
export const getDeploymentsUrl = (migrationId: string) => pathMigrationsDeployments.replace('{migration_id}', migrationId);
export const getReplicationsUrl = (migrationId: string) => pathMigrationsReplications.replace('{migration_id}', migrationId);
export const getCloudsUrl = () => pathClouds;
export const getCloudInstanceUrl = (cloudId: string, instanceId: string) => pathCloudInstances.replace('{cloud_id}', cloudId).replace('{instance_id}', instanceId);
export const getCloudInstanceFetchUrl = (cloudId: string, instanceId: string) => pathCloudInstanceFetch.replace('{cloud_id}', cloudId).replace('{instance_id}', instanceId);
